import { useCallback, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getPublicInterestOptions, type PublicOptionResponse } from "./publicOptions.api";

interface UseGetInterestOptionsReturn {
  interestOptions: PublicOptionResponse[];
  fetchInterestOptions: () => Promise<void>;
}

export const useGetInterestOptions = (): UseGetInterestOptionsReturn => {
  const [interestOptions, setInterestOptions] = useState<PublicOptionResponse[]>([]);
  const { run: runLatestRequest } = useLatestRequest();

  const fetchInterestOptions = useCallback(async () => {
    try {
      const response = await runLatestRequest(getPublicInterestOptions);
      if (!response) return;
      setInterestOptions(response);
    } catch (error) {
      console.error("Failed to fetch interest options:", error);
    }
  }, [runLatestRequest]);

  return {
    interestOptions,
    fetchInterestOptions,
  };
};
